export type UserState = {
  email: string | null;
  roles: Array<string>;
};

export const initialUserState: UserState = {
  email: null,
  roles: [],
};
